import React, { useEffect, useState } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import axios from 'axios';
import envConfig from '../../../bin/env.config';
import { useSelector } from 'react-redux';
import { STATUS_COLORS, STATUS_OPTIONS, BACKGROUND_STATUS_COLORS, formatOodEditedBy } from '../../../utility/statusConfig';

export default function StoreCheckHistoryTable({ company_product_id, store_id }) {
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.session.token);

  useEffect(() => {
    const fetchHistoryData = async () => {
      try {
        setLoading(true);
        const response = await axios.post(
          `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/data-freshness-reporting/out-of-date-store-check-info-history`,
          {
            company_product_id,
            store_id,
          },
          {
            headers: {
              Authorization: token,
            },
          }
        );
        setHistoryData(response.data.data);
      } catch (error) {
        console.error('Error fetching store check history:', error);
      } finally {
        setLoading(false);
      }
    };

    if (company_product_id && store_id) {
      fetchHistoryData();
    }
  }, [company_product_id, store_id, token]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  if (loading) {
    return <div>Loading history data...</div>;
  }

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>By</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {historyData && historyData.map((row, index) => (
            <TableRow key={index} style={{ backgroundColor: BACKGROUND_STATUS_COLORS[row.status_id] }} title={row.note}>
              <TableCell style={{ color: STATUS_COLORS[row.status_id] }}>{formatDate(row.edited_at)}</TableCell>
              <TableCell style={{ color: STATUS_COLORS[row.status_id] }}>
                {STATUS_OPTIONS[row.status_id]}
              </TableCell>
              <TableCell style={{ color: STATUS_COLORS[row.status_id] }}>
                {formatOodEditedBy(row.edited_by, { statusId: row.status_id })}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
